import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex-grow text-left" };
const _hoisted_2 = { class: "overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white w-80" };
const _hoisted_3 = { class: "flex justify-between items-center mb-2 p-2" };
const _hoisted_4 = { class: "text-lg font-bold text-gray-800" };
const _hoisted_5 = { class: "ml-1 text-lg text-gray-600 font-normal" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("svg", {
    class: "h-6 w-6 text-gray-500 inline-flex",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15 19l-7-7 7-7"
    })
], -1);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("svg", {
    class: "h-6 w-6 text-gray-500 inline-flex",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5l7 7-7 7"
    })
], -1);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = { class: "flex flex-wrap mb-3 -mx-1" };
const _hoisted_12 = { class: "text-gray-800 font-medium text-center text-xs" };
const _hoisted_13 = { class: "flex flex-wrap -mx-1" };
const _hoisted_14 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_calendar_icon = _resolveComponent("calendar-icon");
    const _component_popover_button = _resolveComponent("popover-button");
    const _component_popover_panel = _resolveComponent("popover-panel");
    const _component_popover = _resolveComponent("popover");
    return (_openBlock(), _createBlock(_component_popover, null, {
        default: _withCtx(({ open }) => [
            _createVNode(_component_popover_button, {
                class: _normalizeClass([{ 'text-opacity-90 ring-blue-500 border-blue-500': open }, "m-0 z-0 w-full flex px-3 py-2 text-base font-medium text-primary border-gray-300 rounded-md group hover:text-opacity-100 focus:outline-none hover:ring-blue-500 hover:border-blue-500"])
            }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.formatDate(_ctx.modelValue) || _ctx.$t('vault.noLimit')), 1),
                    _createVNode(_component_calendar_icon, {
                        class: _normalizeClass([open ? '' : 'text-opacity-70', "w-5 h-5 ml-2 text-orange-300 transition duration-150 ease-in-out group-hover:text-opacity-80"]),
                        "aria-hidden": "true"
                    }, null, 8, ["class"])
                ]),
                _: 2
            }, 1032, ["class"]),
            _createVNode(_Transition, {
                "enter-active-class": "transition duration-200 ease-out",
                "enter-from-class": "translate-y-1 opacity-0",
                "enter-to-class": "translate-y-0 opacity-100",
                "leave-active-class": "transition duration-150 ease-in",
                "leave-from-class": "translate-y-0 opacity-100",
                "leave-to-class": "translate-y-1 opacity-0"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_popover_panel, { class: "fixed z-10 mt-3 right-0" }, {
                        default: _withCtx(({ close }) => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(`calendar.months.${_ctx.months[_ctx.month].toLowerCase()}`)), 1),
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.year), 1)
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("button", {
                                            disabled: _ctx.isPast(),
                                            type: "button",
                                            class: _normalizeClass([{ 'cursor-not-allowed bg-gray-200': _ctx.isPast() }, "transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 p-1 rounded-full mr-1"]),
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.decreaseMonth()), ["stop"]))
                                        }, _hoisted_8, 10, _hoisted_6),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 p-1 rounded-full",
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.increaseMonth()), ["stop"]))
                                        }, _hoisted_10)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            style: { "width": "14.26%" },
                                            class: "px-1"
                                        }, [
                                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t(`calendar.days.${day.toLowerCase()}`).substring(0, 2)), 1)
                                        ]));
                                    }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emptyDays, (emptyDay) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: emptyDay,
                                            style: { "width": "14.28%" },
                                            class: "cursor-none text-center border p-1 border-transparent text-sm"
                                        }));
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfDays, (dayNumber, dayIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: dayIndex,
                                            style: { "width": "14.28%" },
                                            class: "px-1 mb-1"
                                        }, [
                                            _createElementVNode("div", {
                                                onClick: _withModifiers(($event) => (_ctx.setDate(dayNumber, close)), ["stop"]),
                                                class: _normalizeClass(["cursor-pointer text-center text-sm rounded-full leading-loose hover:text-primary hover:bg-blue-200", { 'bg-blue-200 text-primary': _ctx.isSelectedDay(dayNumber), 'cursor-not-allowed': _ctx.isPast(dayNumber) }])
                                            }, _toDisplayString(dayNumber), 11, _hoisted_14)
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }));
}
